import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=2ed5448a&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=ts&"
export * from "./Home.vue?vue&type=script&lang=ts&"
import style0 from "@/assets/sass/_home.scss?vue&type=style&index=0&id=2ed5448a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed5448a",
  null
  
)

component.options.__file = "Home.vue"
export default component.exports